export default __webpack_public_path__ + "static/media/dinner.2d0d3505.svg";